function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import colors from './colors';
import space from './space';
import { fontFamilies, fontWeights, fonts } from './type';
import { borderRadius, borders, borderPrimitives, bordersAsShadows, shadows, shadowPrimitives } from './objectStyles';
import { springs, easing, duration, delay } from './animation';
import { breakpoints, mediaQueries } from './settings';
export default {
  colors: colors,
  space: space,
  sizes: space,
  // for styled-system
  fontFamilies: fontFamilies,
  fontWeights: fontWeights,
  fonts: fonts,
  borderRadius: borderRadius,
  radii: borderRadius,
  // for styled-system
  borderPrimitives: borderPrimitives,
  borders: borders,
  bordersAsShadows: bordersAsShadows,
  shadows: _objectSpread(_objectSpread({}, shadows), {}, {
    // legacy
    one: '0 0 0 1px hsla(0, 0%, 15%, 0.05), 0 8px 24px -10px hsla(0, 0%, 15%, 0.2)',
    two: '0 2px 6px 0 hsla(0, 0%, 0%, 0.1)',
    input: '0 0 0 3px rgba(0, 0, 0, 0.1)'
  }),
  shadowPrimitives: shadowPrimitives,
  springs: springs,
  easing: easing,
  duration: duration,
  delay: delay,
  breakpoints: breakpoints,
  mediaQueries: mediaQueries
};